import { useCallback } from 'react';
import { api } from '@/redux/api';
import { findById } from '@/utils/find-by-id';
import { useUnits } from './use-units';

export const useUnit = (id: number) => {
  const result = useUnits();

  const unit = findById(result.data, id);

  /**
   * Allow for update of the unit email address
   */
  const [update] = api.useUpdateUnitMutation();
  const updateUnit = useCallback(
    async (email: string): Promise<void> => {
      if (!unit) return;
      await update({
        email,
        id: unit.id,
        organisation: unit.organisation,
        groupId: unit.group?.id,
        uuid: unit?.uuid,
      });
      return;
    },
    [unit, update],
  );

  return { ...result, data: unit, updateUnit };
};
